module.exports = __webpack_public_path__ + "static/FAQ-welcome1-44e472bf313261109c0a8ccb6ed19ea0.jpg";